import {createActions} from 'reduxsauce';

export const {Types: StoreLocationTypes, Creators: StoreLocationActionCreators} = createActions ({
    storeLocationStart: ['data'],
});